// extracted by mini-css-extract-plugin
export var divider = "_yc-0";